import { render, staticRenderFns } from "./PayOrderCertificate.vue?vue&type=template&id=604acd7a&"
import script from "./PayOrderCertificate.vue?vue&type=script&lang=js&"
export * from "./PayOrderCertificate.vue?vue&type=script&lang=js&"
import style0 from "./PayOrderCertificate.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports